import { ItassetService } from './../../../../_services/itasset/itasset.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { Router } from '@angular/router';
import { ActionItemsGridRowRendererComponent } from '../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';

@Component({
  selector: 'app-it-asset',
  templateUrl: './it-asset.component.html',
  styleUrls: ['./it-asset.component.scss']
})
export class ItAssetComponent implements OnInit {
  tenantId: string;
  currentUser: any;
  rowData: any;
  modeAction:number = 1 //1 - create // 2 - update
  public columnDefs: ColDef[]; 
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
  itassetForm: FormGroup;
  form: FormGroup;
  selectedCheckboxData = []
  rowSelection: any;
  defaultColDef:any;9
  deleteConfirmationMsg = 'Are you sure you want to delete'
  userDropdownList = [];
  sampleGridFrameworkComponents: any;
  btappupdateId: any;
  userDetails: any;
  
  constructor(
    private itassetService: ItassetService,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private router: Router, 
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.itassetForm = new FormGroup({
      id: new FormControl(''),
      assetType: new FormControl('', Validators.required),
      assetId: new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$') ]),
      macId: new FormControl(''),
      user: new FormControl('', Validators.required),
      userId: new FormControl(''),
      department: new FormControl('', Validators.required),
      model: new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$') ]),
      sn: new FormControl('', Validators.required),
      pn: new FormControl(''),
      warranty: new FormControl(''),
      installDate: new FormControl('', Validators.required),
      os: new FormControl('', Validators.required),
      vendor: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
      configuration: new FormControl('', Validators.required),
      summary: new FormControl(''),
      expiryForRented: new FormControl(''),
      processor: new FormControl('', Validators.required),
      ram: new FormControl('', Validators.required),
      harddisk: new FormControl('', Validators.required),
      display: new FormControl('', Validators.required),
      keyboard: new FormControl('', Validators.required),
      mouse: new FormControl('', Validators.required),
      installationReleaseDate: new FormControl(''),
      rentalCost: new FormControl(''),
      state: new FormControl('', Validators.required),
      graphicsCard: new FormControl('', Validators.required),
      availableQuantity: new FormControl(''),
    })
  }

    // getter for easy access to form fields
    get f() {
      return this.itassetForm.controls;
    }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getItAssetData();
    this.getUserList();
  }

  getItAssetData() {
    this.itassetService.getAllItasset().subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

    // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
    onGridReady(params): void {
      this.api = params.api;
      console.log('qqqq', this.api)
      this.columnApi = params.columnApi;
      this.api.sizeColumnsToFit();
    } 
  
    // create column definitions  
    private createColumnDefs() {
      return [
      {
        headerName: 'AssetType',
        field: 'assetType',
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Id',
        field: 'id',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'AssetId',
        field: 'assetId',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'MacId',
        field: 'macId',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'User',
        field: 'user',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Department',
        field: 'department',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Model',
        field: 'model',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Sn',
        field: 'sn',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Pn',
        field: 'pn',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Warranty',
        field: 'warranty',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'InstallDate',
        field: 'installDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Os',
        field: 'os',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Vendor',
        field: 'vendor',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Location',
        field: 'location',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Ram',
        field: 'ram',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Processor',
        field: 'processor',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Harddisk',
        field: 'harddisk',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Display',
        field: 'display',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Rental Cost',
        field: 'rentalCost',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'State',
        field: 'state',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Mouse',
        field: 'mouse',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Keyboard',
        field: 'keyboard',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Rental Cost',
        field: 'rentalCost',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Graphics Card',
        field: 'graphicsCard',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Available Quantity',
        field: 'availableQuantity',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },

     ]
    }

    isFirstColumn(params) {
      const displayedColumns = params.columnApi.getAllDisplayedColumns();
      const thisIsFirstColumn = displayedColumns[0] === params.column;
      return thisIsFirstColumn;
    }

    onSelectionChanged(event) {
      this.selectedCheckboxData = []
      let select = event.api.getSelectedNodes();
      for (let item of select) {
        this.selectedCheckboxData.push(item.data)
      }
    }

    createItAsset() {
      let details = JSON.stringify(this.itassetForm.value);
      this.itassetService.createItasset(details).subscribe(response => {
        console.log("response: ", response);
        
        // update grid after creating new lead & close the modal
        this.api.applyTransaction({ add: [response] });
        $('#closeCreateModal').trigger("click");
      });
    }

    editOpenModal() {
      this.modeAction = 2;
      this.itassetForm.patchValue(this.selectedCheckboxData[0])
    }

    createOpenModal() {
      this.modeAction = 1;
      this.itassetForm.reset();
    }

    deleteOpenModal() {
      this.deleteConfirmationMsg = 'Are you sure you want to delete'
      for (let i in this.selectedCheckboxData) {
        if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].assetType} ${this.selectedCheckboxData[i].macId}`;
        else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].assetType} ${this.selectedCheckboxData[i].macId}`;
        else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].assetType} ${this.selectedCheckboxData[i].macId}`;
      }
    }

    updateItAsset() {
      this.itassetService.updateItasset(this.itassetForm.value, this.selectedCheckboxData[0].id).subscribe(res => {
        this.getItAssetData();
        this.selectedCheckboxData = []
        $('#closeCreateModal').trigger("click");
      })
    }

    deleteItAssetList() {
      this.itassetService.deleteItasset(this.selectedCheckboxData[0].id).subscribe(() => {
        this.getItAssetData();
        this.selectedCheckboxData = []
        $('#closeModalDeleteItAsset').trigger("click");
      });
    }

    getUserList() {
      this.userDropdownList = []
      this.allocationService.getUserDetails().subscribe(response => {
        for (let item of response) {
          this.userDropdownList.push(` ${item.firstName} ${item.lastName}`)
        }
      })
    }

    openbaApp(){
      this.router.navigate([this.tenantId + '/dashboard/itm/it-asset-form']);
    }

    updateBtApp(){
      let selectedNodes = this.api.getSelectedNodes();
      let selectedData = selectedNodes.map((node) => node.data);
      let editId = selectedNodes.map((node) => node.data.id);
      this.router.navigate([
        this.tenantId + '/dashboard/itm/it-asset-form',
        { id: this.selectedCheckboxData[0].id },
      ]);
    }

}
